import { api } from '../lib/api'

export interface ManagerActivity {
  id: string
  name: string
  email: string
  lastActivityAt: string | null
  activeByDay: boolean[] // mesma ordem de `days` (último = hoje, SP)
  activeDaysCount: number
}

export const activityApi = {
  managers: () =>
    api.get<{ days: string[]; managers: ManagerActivity[] }>('/activity/managers'),
}
